<template>
  <div class="z-tabs-pane" :class="classes"
  v-if="active">
    <slot></slot>
  </div>
</template>
<script>
  export default {
    inject: ["eventBus"],
    data () {
      return {
        active:false  
      }
    },
    props: {
      name: {
        type: String | Number,
        required: true
      }
    },
    computed:{
      classes(){
        return {
          active:this.active
        }
      }
    },
    mounted() {
      this.eventBus.$on("update:selected", name => {
        if(name===this.name){
          this.active= true
        }else{
          this.active = false
        }
      });
    },
  };
</script>

